import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./PublicNavigation.css";

const PublicNavigation: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <>
      <header className="public-header">
        <nav className="public-nav">
          <Link to="/" className="public-logo">
            CosaVorrei
          </Link>
          
          <button
            className="public-hamburger"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span className={`public-hamburger-line ${isMobileMenuOpen ? "open" : ""}`}></span>
            <span className={`public-hamburger-line ${isMobileMenuOpen ? "open" : ""}`}></span>
            <span className={`public-hamburger-line ${isMobileMenuOpen ? "open" : ""}`}></span>
          </button>

          <div className={`public-nav-content ${isMobileMenuOpen ? "mobile-open" : ""}`}>
            <div className="public-nav-links">
              <Link 
                to="/" 
                className={`public-nav-link ${isActive("/") ? "active" : ""}`}
                onClick={closeMobileMenu}
              >
                Home
              </Link>
              <Link 
                to="/come-funziona" 
                className={`public-nav-link ${isActive("/come-funziona") ? "active" : ""}`}
                onClick={closeMobileMenu}
              >
                Come funziona
              </Link>
            </div>

            <div className="public-nav-actions">
              <Link to="/login" className="public-nav-btn" onClick={closeMobileMenu}>
                Accedi
              </Link>
            </div>
          </div>
        </nav>
      </header>

      {/* Overlay per chiudere il menu su mobile */}
      {isMobileMenuOpen && (
        <button
          className="public-mobile-overlay"
          onClick={closeMobileMenu}
          aria-label="Close menu"
        ></button>
      )}
    </>
  );
};

export default PublicNavigation;
